<template>
  <div :style="cssProps">
    <b-row class="main-container">
      <b-col cols="1" lg="1" md="1" sm="1" class="mobile-web-icon">
        <img src="static/img/icon_mobile-web-svg.svg" height="40" width="40" />
      </b-col>
      <b-col cols="10" lg="11" md="11" sm="10" class="mobile-content">
        <div id="SearchParameters" ref="disclaimerContent" class="content-container" :class="toggleExpandSection ? 'toggle-open' : 'toggle-closed'" v-html="widget.translate('PAPP_disclaimer_text', disclaimerText)"></div>
      </b-col>
    </b-row>
    <b-row class="collapsible-xs-section" @click="toggleExpandibleSection">
      <b v-if="toggleExpandSection">{{ widget.translate("PAPP_less_details_text", "Less Details") }}</b>
      <b v-else>{{ widget.translate("PAPP_more_details_text", "More Details") }}</b>
      <i class="fa fa-angle-down caret-icon" :class="{ 'toggle-section': toggleExpandSection }" aria-hidden="true"></i>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "participant-login-disclaimer",
  components: {},
  props: {
    languageCulture: {
      type: String,
      default: "EN"
    },
    widget: {
      type: Object,
      default: () => {}
    },
    isDisclaimerVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      toggleExpandSection: false,
      contentHeight: "35px", // default height
      disclaimerText:
        "<b>Some study-related functions may be limited when accessing the study from an Internet browser.</b><br/><br/>Certain features including Bluetooth, webcam-based functionality, and other complex attributes are not currently available when using a web browser. Please use the participant app on a mobile device to experience the full set of study features and activities.<br/><br/><i>Please contact your study team for further assistance.</i>"
    };
  },
  computed: {
    cssProps() {
      return {
        "--contentHeight": this.contentHeight
      };
    }
  },
  mounted() {
    this.getHeightOfDisclaimerHeading();
    window.addEventListener("resize", this.getHeightOfDisclaimerHeading);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getHeightOfDisclaimerHeading);
  },
  watch: {
    isDisclaimerVisible: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.getHeightOfDisclaimerHeading();
        }
      }
    }
  },
  methods: {
    toggleExpandibleSection() {
      this.toggleExpandSection = !this.toggleExpandSection;
    },
    getHeightOfDisclaimerHeading() {
      const contentOffsetHeight = this.$refs && this.$refs.disclaimerContent && this.$refs.disclaimerContent.children && this.$refs.disclaimerContent.children.length && this.$refs.disclaimerContent.children[0] && this.$refs.disclaimerContent.children[0].offsetHeight;
      this.contentHeight = contentOffsetHeight ? contentOffsetHeight + "px" : this.contentHeight;
    }
  }
};
</script>

<style scoped lang="scss">
@media only screen and (min-width: 600px) {
  .main-container {
    background-color: #e8f5fc;
    border: solid 1px #c9e7f8;
    margin-bottom: 29px !important;
    padding: 24px 24px 24px 24px;

    .mobile-web-icon {
      max-width: max-content !important;
      padding-right: 0px !important;
      padding-left: 0px !important;
    }

    .content-container {
      font-family: Roboto-Regular;
      font-size: 15px;
      line-height: 1.15em;
      color: #004f71;
      & >>> b {
        font-family: Roboto-Medium;
        font-weight: 900;
        font-size: 17px !important;
      }

      & >>> i {
        font-family: Roboto-Medium;
        font-size: 15px;
      }
    }
  }

  .collapsible-xs-section {
    display: none;
  }
}

// For mobile screens
@media only screen and (max-width: 600px) {
  @-webkit-keyframes opened {
    0% {
      height: var(--contentHeight);
    }
    100% {
      height: 100%;
    }
  }

  @-moz-keyframes opened {
    0% {
      height: var(--contentHeight);
    }
    100% {
      height: 100%;
    }
  }

  @-o-keyframes opened {
    0% {
      height: var(--contentHeight);
    }
    100% {
      height: 100%;
    }
  }

  @keyframes opened {
    0% {
      height: var(--contentHeight);
    }
    100% {
      height: 100%;
    }
  }

  .main-container {
    background-color: #e8f5fc;
    border: solid 1px #c9e7f8;
    padding: 24px 24px 17px 24px;
    margin: 0px !important;

    .mobile-web-icon {
      max-width: max-content !important;
      padding-right: 0px !important;
      padding-left: 0px !important;
      & img {
        height: 35px !important;
      }
    }

    .mobile-content {
      padding-right: 0px !important;
    }

    .content-container {
      font-family: Roboto-Regular;
      font-size: 12px;
      color: #004f71;
      overflow: hidden;
      line-height: 1.15em;
      height: var(--contentHeight);
      & >>> b {
        font-family: Roboto-Medium;
        font-weight: 900;
        font-size: 14px;
        line-height: 1.1em;
      }

      & >>> i {
        font-family: Roboto-Medium;
        font-size: 12px;
      }

      &.toggle-open {
        -webkit-animation: opened 2000ms ease-in-out -1900ms 1 normal forwards;
        -moz-animation: opened 2000ms ease-in-out -1900ms 1 normal forwards;
        -o-animation: opened 2000ms ease-in-out -1900ms 1 normal forwards;
        animation: opened 2000ms ease-in-out -1900ms 1 normal forwards;
      }
      &.toggle-closed {
        -webkit-animation: opened 2s ease-in-out 0s 1 normal reverse;
        -moz-animation: opened 2s ease-in-out 0s 1 normal reverse;
        -o-animation: opened 2s ease-in-out 0s 1 normal reverse;
        animation: opened 2s ease-in-out 0s 1 normal reverse;
      }
    }
  }

  .collapsible-xs-section {
    justify-content: center;
    padding: 5px 0px 5px 0px;
    background-color: #e8f5fc;
    b {
      font-family: Roboto-Medium;
      font-weight: 900;
      font-size: 12px;
      color: #004f71;
    }

    .caret-icon {
      color: #004f71;
      font-size: 13px;
      font-weight: 900;
      margin: 4px 0px 2px 9px;
      transform: rotate(0deg);
      transition: transform 300ms linear;
    }

    .caret-icon.toggle-section {
      transform: rotate(-180deg);
      transition: transform 300ms linear;
      margin: 2px 0px 3px 9px !important;
    }
  }
}
</style>
